module.exports = __webpack_public_path__ + "static/media/water_level_8.16a83e4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/water_level_8.png
// module id = 314
// module chunks = 2